import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconMagnifyingSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.086 6.79a4.693 4.693 0 1 1 5.214 7.805 4.693 4.693 0 0 1-5.214-7.804ZM10.693 4a6.693 6.693 0 1 0 3.97 12.081l4.031 4.03.707.708 1.415-1.414-.708-.707-4.03-4.03A6.692 6.692 0 0 0 10.693 4Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconMagnifyingSharp);
export default Memo;
